import React from "react";

export function TermsModal({ isVisible, onClose, onAccept }) {
  if (!isVisible) return null;

  const styles = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: "rgba(0, 0, 0, 0.55)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 2000,
    },
    modal: {
      background: "#fff",
      borderRadius: "12px",
      width: "80%",
      maxWidth: "700px",
      maxHeight: "85vh",
      padding: "24px",
      position: "relative",
      overflow: "hidden",
      boxShadow: "0 4px 16px rgba(0, 0, 0, 0.2)",
    },
    closeBtn: {
      position: "absolute",
      top: "12px",
      right: "12px",
      border: "none",
      background: "transparent",
      fontSize: "22px",
      cursor: "pointer",
      color: "#666",
      width: "32px",
      height: "32px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    title: {
      textAlign: "center",
      marginTop: "8px",
      marginBottom: "16px",
      fontSize: "1.4rem",
      color: "#333",
      fontWeight: "600",
    },
    scrollContainer: {
      overflowY: "auto",
      maxHeight: "70vh",
      paddingRight: "8px",
    },
    heading: {
      fontSize: "1rem",
      marginTop: "1.2em",
      marginBottom: "0.3em",
      color: "#444",
      fontWeight: "600",
    },
    paragraph: {
      fontSize: "0.95rem",
      color: "#555",
      marginBottom: "0.8em",
      lineHeight: "1.5",
    },
    link: {
      color: "#007bff",
      textDecoration: "none",
    },
    linkHover: {
      textDecoration: "underline",
    },

    acceptBtn: {
      backgroundColor: "#0f766e",
      color: "white",
      border: "none",
      padding: "10px 24px",
      borderRadius: "8px",
      cursor: "pointer",
      fontSize: "1rem",
      fontWeight: "600",
      transition: "background-color 0.2s",
    },
    actions: {
      display: "flex",
      justifyContent: "center",
      paddingTop: "16px",
      marginTop: "16px",
      borderTop: "1px solid #e2e8f0",
    },
    acceptBtnHover: {
      backgroundColor: "#0f766e",
    }
  };

  return (
    <div style={styles.overlay}>
      <div style={styles.modal}>
        {/* Botón de cerrar */}

        <button
          style={styles.closeBtn}
          onClick={onClose}
          aria-label="Cerrar términos y condiciones"
        >
          ✕
        </button>

        <h2 style={styles.title}>Términos y Condiciones de Uso</h2>

        <div style={styles.scrollContainer}>
          <p style={styles.paragraph}>
            Términos y Condiciones regulan el
            acceso y uso de la plataforma web y móvil.
          </p>
          <p style={styles.paragraph}>
            Estos Términos y Condiciones constituyen un contrato vinculante entre
            el Usuario y el Equipo. El acceso o uso de la plataforma
            implica la aceptación total y sin reservas de este documento.
          </p>

          <h3 style={styles.heading}>1. DEFINICIONES</h3>
          <p style={styles.paragraph}>
            • <strong>Usuario:</strong> Toda persona natural mayor de edad que
            accede, se registra o utiliza la plataforma.
          </p>
          <p style={styles.paragraph}>
            • <strong>Denunciante:</strong> Usuario que reporta una incidencia
            urbana a través de la plataforma.
          </p>
          <p style={styles.paragraph}>
            • <strong>Receptor Municipal:</strong> Usuario autorizado por la
            Municipalidad de La Plata para recibir, gestionar y dar seguimiento a
            las denuncias.
          </p>
          <p style={styles.paragraph}>
            • <strong>Servicios:</strong> Funcionalidades de  ,
            incluyendo creación de reportes, seguimiento de denuncias,
            notificaciones y acceso a datos estadísticos.
          </p>

          <h3 style={styles.heading}>2. REGISTRO Y CUENTAS</h3>
          <p style={styles.paragraph}>
            • Para utilizar los Servicios, el Usuario debe registrarse
            proporcionando datos veraces y actualizados (nombre, correo
            electrónico, ubicación).
          </p>
          <p style={styles.paragraph}>
            • El Usuario es responsable de la confidencialidad de sus credenciales
            y de cualquier actividad realizada bajo su cuenta.
          </p>
          <p style={styles.paragraph}>
            •   podrá suspender o cancelar cuentas en caso de
            incumplimiento de estos Términos o uso fraudulento.
          </p>

          <h3 style={styles.heading}>3. USO DE LOS SERVICIOS</h3>
          <p style={styles.paragraph}>
            • <strong>Reportes de Incidencias:</strong> El Denunciante podá crear
            y enviar reportes con descripción, fotos y ubicación geográfica de la
            incidencia urbana.
          </p>
          <p style={styles.paragraph}>
            • <strong>Seguimiento:</strong> El Receptor Municipal gestionará la
            denuncia e informará al Denunciante sobre el estado y resolución.
          </p>
          <p style={styles.paragraph}>
            • <strong>Notificaciones:</strong> La plataforma enviará alertas al
            Usuario acerca del avance de sus reportes y actividades relevantes.
          </p>

          <h3 style={styles.heading}>4. OBLIGACIONES DEL USUARIO</h3>
          <p style={styles.paragraph}>
            • Proporcionar información precisa y no falsa; se prohíbe el envío de
            denuncias maliciosas o infundadas.
          </p>
          <p style={styles.paragraph}>
            • Respetar los derechos de terceros y las normas legales vigentes; no
            cargar contenido ofensivo, difamatorio o ilegal.
          </p>
          <p style={styles.paragraph}>
            • No intentar vulnerar la seguridad de la plataforma ni ejecutar
            acciones que comprometan su disponibilidad.
          </p>

          <h3 style={styles.heading}>5. OBLIGACIONES DE  </h3>
          <p style={styles.paragraph}>
            • Mantener la plataforma operativa y actualizarla regularmente para
            garantizar la correcta prestación de los Servicios.
          </p>
          <p style={styles.paragraph}>
            • Proteger la información personal de los Usuarios conforme a su
            Política de Privacidad.
          </p>
          <p style={styles.paragraph}>
            • Brindar soporte técnico y canal de contacto para consultas o
            incidencia en el uso de la plataforma.
          </p>

          <h3 style={styles.heading}>6. PROPIEDAD INTELECTUAL</h3>
          <p style={styles.paragraph}>
            • Todos los derechos de propiedad intelectual e industrial sobre la
            plataforma, su código fuente, diseños, marcas y contenidos son de
            titularidad exclusiva de  .
          </p>

          <h3 style={styles.heading}>7. PROTECCIÓN DE DATOS Y PRIVACIDAD</h3>
          <p style={styles.paragraph}>
            • El tratamiento de datos personales se regirá por la Política de
            Privacidad de  , disponible en nuestra web.
          </p>

          <h3 style={styles.heading}>8. EXENCIÓN DE RESPONSABILIDAD</h3>
          <p style={styles.paragraph}>
            •   no será responsable por daños directos, indirectos, lucro
            cesante o cualquier perjuicio derivado del uso inadecuado de la
            plataforma.
          </p>

          <h3 style={styles.heading}>9. MODIFICACIONES</h3>
          <p style={styles.paragraph}>
            •   se reserva el derecho de modificar estos Términos en
            cualquier momento.
          </p>
          <p style={styles.paragraph}>
            • Si el Usuario no está de acuerdo con las modificaciones, deberá
            dejar de utilizar la plataforma.
          </p>

          <h3 style={styles.heading}>10. LEY APLICABLE Y JURISDICCIÓN</h3>
          <p style={styles.paragraph}>
            • Estos Términos se regirán por las leyes de la República Argentina.
          </p>

          <h3 style={styles.heading}>CONTACTO</h3>
          <p style={styles.paragraph}>
            • Para consultas sobre estos Términos y Condiciones, escribir a:{" "}
            <a
              href="mailto:soporte@ gmail.lp.gob.ar"
              style={styles.link}
              onMouseEnter={(e) => e.target.style.textDecoration = "underline"}
              onMouseLeave={(e) => e.target.style.textDecoration = "none"}
            >
              soporte@gmail.lp.gob.ar
            </a>
          </p>
        </div>

        {/* Botón Aceptar */}
        <div style={styles.actions}>
          <button
            style={styles.acceptBtn}
            onClick={onAccept}
            onMouseEnter={(e) => e.target.style.backgroundColor = "#0f766e"}
            onMouseLeave={(e) => e.target.style.backgroundColor = "#0d9488"}
          >
            Aceptar Términos
          </button>
        </div>

      </div>
    </div>
  );
}